// CORE
import { executeRequest, type ApiResult } from '@/core/either';
import { http } from '@/core/api';

// TYPES
import type { GetDiscountCoupon } from '@/types/DiscountsType';
import type { TypeCoupon } from '@/types/QuoteType';

export const discountService = {
  /**
   * Obtiene y valida un cupón de descuento para una transacción.
   * @param data - Datos del cupón incluyendo código promocional y detalles de la ruta.
   * @returns Promesa con el resultado tipado usando Either (ApiResult<TypeCoupon>).
   */
  getDiscountCoupon(data: GetDiscountCoupon): Promise<ApiResult<TypeCoupon>> {
    return executeRequest(() =>
      http.post<TypeCoupon>('discounts/b2b/promotions/check', data)
    );
  },
};
